<template>
	<div>
		<v-dialog v-model="dialog_filter_year" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>
                        Select Fiscal Year
                    </v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>
			        <v-list nopadding>
                        <template v-for="(item, index) in fiscalYears">
                            <v-list-tile @click="selectPeriod('fiscal_year', 12, item.value)" :key="index" v-if="fn_checkOpeningDate(item.value)">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{item.title}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
        props:['selectPeriod'],
		data(){
			return{
				dialog_filter_year:false,
                selectedFiscalYear:null,
                fiscalYears:[
                    // {"title":"FY 2021", "value":2021},
                    // {"title":"FY 2022", "value":2022}
					{"title":"FY 22-23", "value":2022},
					{"title":"FY 23-24", "value":2023},
					{"title":"FY 24-25", "value":2024},
					{"title":"FY 25-26", "value":2025},
					{"title":"FY 26-27", "value":2026}
                ]
			}
		},
		methods:{
			openDialogWeb: function () {
                // let maxYear = new Date(this.$root.maxDateSelection).getFullYear();

                // let currentDate = new Date();
                // let currentYear = currentDate.getFullYear() > maxYear ? maxYear : currentDate.getFullYear();
                // let currentMonth = currentDate.getMonth() + 1;

                // let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                // let openingYear = openingDate.getFullYear();
                // let openingMonth = openingDate.getMonth() + 1;

                // let openingFY = openingMonth <= 3 ? (openingYear - 1) : openingYear;
                // let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

                // this.selectedFiscalYear = currentFY > openingFY ? currentFY : openingFY;

                this.dialog_filter_year = true;
            },
			closeDialogWeb: function () {
				this.dialog_filter_year = false;
			},
			fn_closeDialog: function(){
				if(this.$parent.fn_closeDialog){
					this.$parent.fn_closeDialog();
				}
				else{
					this.closeDialogWeb();
				}
			},
			fn_checkOpeningDate: function(item){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                if(item >= openingYear){
                    return true;
                }
                else{
                    return false;
                }
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_filter_fiscalyear.vue